import { Navigate } from "react-router-dom";

import { Loader } from "@braintrust/braintrust-ui-components";
import { EmployerEditWizard } from "@js/apps/employer/components/employer-edit-wizard";
import { useCanSetupATSIntegration } from "@js/apps/employer/hooks/use-can-setup-ats-integration";

import { ATSIntegrationViewLazy } from "../../lazy";

export const ATSIntegrationPage = () => {
  const { canSetupATSIntegration, isLoading } = useCanSetupATSIntegration();

  if (isLoading) {
    return <Loader centered />;
  }

  if (!canSetupATSIntegration) {
    return <Navigate to="/" replace />;
  }

  return (
    <EmployerEditWizard pageTitle="ATS integration">
      <ATSIntegrationViewLazy />
    </EmployerEditWizard>
  );
};
